<template>
  <el-dialog
    :title="formTitle"
    :visible.sync="isVisible"
    class="dialog-non-conformity-dysfunction-form"
    custom-class="dialog-short-form"
    :class="{'is-edit-mode': isEditMode, 'is-new': state === 'new'}"
    :closeOnClickModal="false"
    append-to-body
    @close="handleDialogClose">
    <div class="non-conformity-dysfunction-form-content" v-loading="isLoading">
      <form-editor
        :data="data"
        :model="formModel"
        @updateModelItem="handlerUpdateModelItem"
        @change="handleFormData"
        ref="Form"/>
      <form-controls
        class="form-footer"
        :isBack="isAvailableToSave"
        :isCancel="!isAvailableToSave"
        :isCreate="!hasCreateNew"
        :isSave="hasCreateNew"
        :isDelete="hasCreateNew"
        @command="setCommand"/>
    </div>
  </el-dialog>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'

export default {
  name: 'ModalNewNonConformityDysfunction',
  mixins: [FormWrapper, FormWrapperAutoSave],
  components: {
    'form-editor': () => import(/* webpackChunkName: 'NonConformityDysfunction' */ './Form'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls')
  },
  props: {
    config: { type: Object }
  },
  data () {
    return {
      // eslint-disable-next-line
      apiPatch: 'NonConformityDysfunctions/Patch/${data.id}'
    }
  },
  computed: {
    formTitle () {
      return this.formData.title || this.checkEs6AndRun(this.title)
    }
  },
  methods: {
    formModel () {
      return {
        id: '',
        title: ''
      }
    },
    handleDialogClose () {
      let command = this.isAvailableToSave ? 'back' : 'cancel'
      this.setCommand(command)
    }
  }
}
</script>

<style lang="stylus">
</style>
